import React, { Component } from "react";
import styles from "./CollaboratorSpace.local.scss";
import classnames from "classnames";

class CollaboratorPresentationsFetching extends Component {
  render() {
    let status = [];
    let presentations = [];
    for (let i = 0; i < 3; i++) {
      status.push(
        <div
          key={i}
          className={classnames("column medium-4", styles.frame_fetching)}
        >
          <div />
          <div className={classnames(styles.content, styles.gradiant)} />
        </div>
      );
      presentations.push(
        <div key={i} className={styles.div_fetching}>
          <div className={styles.gradiant} />
          <div className={styles.gradiant} />
        </div>
      );
    }
    presentations.push(
      <div key={3} className={styles.div_fetching}>
        <div className={styles.gradiant} />
        <div className={styles.gradiant} />
      </div>
    );
    return (
      <div className={styles.large_section_fetching}>
        <div className={styles.frames_fetching}>{status}</div>
        <div>{presentations}</div>
      </div>
    );
  }
}

export default CollaboratorPresentationsFetching;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorPresentationsFetching.js